import { css, styled } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScScratchTicket = styled.div<{
  isPremium?: boolean;
  isFinished?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  width: 397px;
  height: 270px;
  margin-inline: auto;
  padding: 33px 42px 45px;
  text-align: center;
  z-index: 1;
  max-width: 100%;

  @media (${device.mobile}) {
    width: 298px;
    height: 203px;
    padding: 30px 25px 33px;
  }

  & > .ticket {
    z-index: -1;
  }

  & > .top-text {
    & > .title {
      ${typography['headline2']}
      text-transform: uppercase;
      margin-bottom: 8px;

      @media (${device.mobile}) {
        ${typography['headline3mobile']}
      }
    }

    & > .subtitle {
      ${typography['body2bold']}

      @media (${device.mobile}) {
        ${typography['caption1bold']}
      }
    }
  }

  & .scratch-field-box {
    width: 270px;
    margin-inline: auto;

    @media (${device.mobile}) {
      width: 210px;
    }
  }

  & .scratch-field {
    position: relative;
    z-index: 1;
    height: 56px;
    box-shadow: inset 0 0 0 2px
      ${({ theme, isPremium }) => (isPremium ? theme.yellowColor : '#898079')};
    border-radius: 12px;
    display: grid;
    place-items: center;
    overflow: hidden;

    @media (${device.mobile}) {
      height: 40px;
    }

    &.locked {
      pointer-events: none;
    }

    &:not(.locked) {
      ${({ isFinished }) =>
        !isFinished &&
        css`
          cursor:
            url(data:image/png;base64,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)
              20 20,
            auto;
        `}
    }

    & > i {
      font-size: 32px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;

      @media (${device.mobile}) {
        font-size: 24px;
      }
    }

    & .prize {
      ${typography['headline1']}
      font-weight: 700;

      @media (${device.mobile}) {
        ${typography['headline2']}
      }

      ${({ isPremium }) =>
        isPremium &&
        css`
          background: linear-gradient(
            90deg,
            #bd5d0d 0%,
            #ffec93 50%,
            #bd5d0d 100%
          );
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        `}
    }

    & .ScratchCard__Canvas {
      left: 0;
    }

    & canvas {
      -webkit-user-select: none;
      -webkit-touch-callout: none;
      touch-action: manipulation;
    }

    & .ScratchCard__Result {
      display: grid;
      place-items: center;
    }
  }

  & .possible-prizes {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 8px;
    min-height: 20px;
    ${typography['body2regular']}

    @media (${device.mobile}) {
      ${typography['caption2regular']}
    }
  }
`;
